module.exports = __webpack_public_path__ + "static/media/report-message-icon.940ad22e.svg";